import type { AdminEvent } from "@/lib/admin-api-types";
import type { Event } from "@/lib/api-types";
import { withEventFallbacks } from "@/lib/site-content-fallbacks";

/** True when published and schedule (if set) has been reached. */
export function isEventPublished(
  event: AdminEvent,
  now: Date = new Date()
): boolean {
  if (event.published === false) return false;
  if (!event.publishAt) return true;
  const at = Date.parse(event.publishAt);
  if (Number.isNaN(at)) return false;
  return at <= now.getTime();
}

export function adminEventToPublicEvent(event: AdminEvent): Event {
  const status =
    event.status === "completed" || event.status === "Completed"
      ? "completed"
      : "upcoming";

  return withEventFallbacks([
    {
      id: event.id,
      title: event.title,
      date: event.date,
      description: event.description,
      status,
      items: event.items ?? null,
      images: event.images ?? [],
      heroImage: event.heroImage ?? null,
      featured: event.featured ?? false,
    },
  ])[0];
}

export { resolveEventsHeroImage as pickEventsHeroImage } from "@/lib/site-content-fallbacks";
